// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1m_oC","title":"AfterFrontImage_title__-yQap"};